/**
 * Sprint EMAIL-X Phase 2.6 — central contact-info constants.
 *
 * Single source of truth for the support email + phone shown across
 * the platform (Access Restricted page, footers, support links, etc.).
 * Keeps the brand contact details in one place so future changes are
 * a one-line edit.
 */

export const SUPPORT_EMAIL = "diplomexa.info@factskoot.com";
export const SUPPORT_PHONE_DISPLAY = "+91 9844139333";
export const SUPPORT_PHONE_TEL = "+919844139333";
export const SUPPORT_WHATSAPP_URL = "https://wa.me/919844139333";
export const SUPPORT_TICKET_PATH = "/dashboard/helpdesk";
